import { multiplierHelper } from '../../../../utils/numbers';

interface MultiplierProps {
  totalBuyIn: number;
  prizePool: number;
  isPlayMoney: boolean;
}

export const Multiplier: React.FC<MultiplierProps> = ({ totalBuyIn, prizePool, isPlayMoney }) => (
  <td className="prize-distribution-table-cell">
    {multiplierHelper({
      buyIn: totalBuyIn,
      prizePool,
      isPlayMoney
    })}
  </td>
);
